import apiClient from "../core/HttpClient";
import {AppFile} from "../models";
export default class AppFileService{
    url="/AppFiles";
    async getAppFiles():Promise<AppFile[]>{
        return apiClient.get(this.url).then((response) => {
            return response.data;
        });        
    }
    async getAppFile(id: string):Promise<AppFile>{
        return apiClient.get(`${this.url}/${id}`).then((response) => {
            return response.data;
        });        
    }

    async addAppFile(data: FormData) {
        return apiClient.post(this.url, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }) ;
    }

    async updateAppFile(id: string, data: AppFile): Promise<AppFile> {
        return apiClient.put(`${this.url}/${id}`, data).then((response) => {
            return response.data;
        });
    }

    async deleteAppFile(id: string) {
        return apiClient.delete(`${this.url}/${id}`);
    }
    

}